import { Component, OnInit, Input } from '@angular/core';
import { NgbModal,NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 
import { Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import {CommonService} from '../../services/common.service'
import { APIService, myCurrency } from 'src/app/api.service';
import { DataService } from 'src/app/services/data.service';
import {ItemEntryComponent} from '../item-entry/item-entry.component'
import {ProductBOMComponent} from '../product-bom/product-bom.component'
import {ProductUnitsComponent} from '../product-units/product-units.component'
import {ProductByproductsComponent} from '../product-byproducts/product-byproducts.component'
import {StageSelectionComponent} from '../stage-selection/stage-selection.component';
import { Observable, of, BehaviorSubject } from "rxjs";
import {MatExpansionModule, MatAccordion} from '@angular/material/expansion'
import { ProjectTypeEntryComponent } from 'src/app/projects/project-type-entry/project-type-entry.component';
@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {

  constructor(private modalService: NgbModal, private router: Router, public commonFun: CommonService,
    private apiService: APIService, private dataSer: DataService, private activeModal: NgbActiveModal) {
      // let getParm =  this.commonFun.GetParam("FR");
      // alert(getParm);
      // if(getParm == 'Doc'){
      //   alert(77);
      // }
      // else{
      //   //nothing
      // }  
    }

    @Input() ItemID: any;
    @Input() mdlRef: any;
    @Input() stockItems: any = [];
    @Input() stockCmp: any;
    
    public tmpBOMData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
 
  
  //#region "Declaration"

  productDetials : any = {
    productID: 0,
    productName: '',
    productCode: '',
    stockQty: 0,
    storeID: 0,
    storeName: '',
    stdCost: 0,
    leadTime: 0,
    defPrice: 0,
    unitName: '',
    unitID: 0,
    sorce: '',
    bom: [],
    byProduct: [],
    stages: [],
    units: [],
    isMfg: false,
    categoryName:'',
    subCategoryName:'',
    TypeID:'',
    HSNID:0,
    isActiveStatus: 1,
    initQty: '',
    createdDT: '',
    initUnit: ''
  }
  BasicData: any = [];
  closeResult: any;
  modalReference: any;
  modalReferenceItemEntry: any;
  closeResultEntry: any;
  modalReferenceBOMEntry: any;
  closeResultBOMEntry: any;
  modalReferenceUnitEntry: any;
  closeResultUnitEntry: any;
  modalReferenceByproductEntry: any;
  closeResultByproductEntry: any;
  showComponent: any = {
    isShowStages: false,
    isShowUnit: false
  };
  BOMData = this.tmpBOMData.asObservable();
  ByproductData: any = [];
  stageData: any = [];
  productUnitData: any = [];
  jarvisData: any = [];
  getData: any = [];
  agencyData: any = [];
  categories:any = [];
  tagList:any = [];
  right: any;
  isRateView: boolean = false

  myCurrency: any = myCurrency();

  productBOMList: any = [];
  innerWidth: any;
  isMobileView: boolean = false;

  today = new Date();
  
  // Track if any changes were made
  hasChanges: boolean = false;
//#endregion

goBack() {
  let doneObj = {
    action: 'Done',
    obj: '',
    changeType: this.hasChanges ? 'UPDTPKG' : ''
  }
  this.mdlRef.close(doneObj);
}

editStock() {
  if (!this.stockCmp) return;

  let item = [];
  if (this.stockCmp.zeroQtyItems) {
    item = this.stockCmp.IncludeZeroqtyItms.filter((x: any) => x.ItemID == this.productDetials.productID);
  } else {
    item = this.stockCmp.Items.filter((x: any) => x.ItemID == this.productDetials.productID);
  }

  if (item.length > 0) {
    this.mdlRef.close();
    if (this.stockCmp.isEnableBatches && item[0].BatchType != 0) {
      this.stockCmp.openStrBatchQtyMdl(this.stockCmp.qtyStrBatch, item[0].StoreBatches, item[0].ItemID, item[0].Batches);
    } else {
      this.stockCmp.openQty(this.stockCmp.qtyEdit, item[0].StoreBatches, item[0].ItemID);
    }
  }
}
   

  ngOnInit(): void {
    let productID = this.ItemID //this.commonFun.GetParam("PID");
    this.productDetials.productID = productID;
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
          this.getProductDetail();
    };
    this.dataSer.updateItems([]);
    this.dataSer.updateStockItems(this.stockItems);
    let tempCategoryList:any = this.apiService.getCookie("ERP_Cfg");
    let parseCategory = JSON.parse(tempCategoryList)
    this.categories = JSON.parse(parseCategory[0].ItemCategories)

    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      if(!this.right.InvMstrs && !this.right.InvCfg && !this.right.InvRpts && !this.right.InvXns){
        window.location.href = "../../main.html#/home";
        return;
      }
      if(this.right.InvRateView.toString() != "undefined"){
        this.isRateView = this.right.InvRateView
     }
    }

    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1000) {
        this.isMobileView = true;
    }
  }

  //#region "Function"

  openItemSelModal(content: any) {
    this.modalReference = this.modalService.open(content,  { windowClass : "subGroupModalClass", backdrop: 'static', keyboard: false });
  }

  getSelectedItem(obj: any) {
    this.getData = obj;
  }

  //openStage() - Open Stage Component on Website Page
  // openStage(){
  //   this.showComponent.isShowStages = true;
  //   this.showComponent.isShowUnit = false;
  // }

  //openNewStage() - Redirect to next page
  openNewStage(content: any){
    let stageList = {
      productID: this.productDetials.productID,
      productName: this.productDetials.productName,
      stages: JSON.stringify(this.productDetials.stages)
    };
    // this.stageData = stageList;
    this.modalReferenceBOMEntry = this.modalService.open(StageSelectionComponent, { windowClass: 'item-Edit-Stage', backdrop: 'static', keyboard: false });
    this.modalReferenceBOMEntry.componentInstance.mdlRef = this.modalReferenceBOMEntry;
    this.modalReferenceBOMEntry.componentInstance.stageData = stageList;
    this.modalReferenceBOMEntry.result.then((result: any) => {
      if(result == 'Done'){
          this.getProductDetail();
      }
    })
    // this.modalReferenceBOMEntry.result.then((result: any) => {
    // this.closeResultBOMEntry = `Closed with: ${result}`;
    // }, (reason: any) => {
    //   this.closeResultBOMEntry = `Dismissed`;
    // });
    // // this.dataSer.fn_dataTransfer(stageList);
    // // this.router.navigateByUrl('/Stages?PID=' + this.productDetials.productID);
  }

  //fn_OpenBOM() - Open BOM Page
  fn_OpenBOM(){
    let BOMList = {
      productID: this.productDetials.productID,
      productName: this.productDetials.productName,
      BOM: JSON.stringify(this.productDetials.bom)
    };
    this.dataSer.fn_dataTransfer(BOMList);
    this.router.navigateByUrl('/ProductBOM?PID=' + this.productDetials.productID);
  }

  //fn_OpenBOM() - Open BOM Page
  fn_OpenWebBOM(content: any){
    let BOMList = {
      productID: this.productDetials.productID,
      productName: this.productDetials.productName,
      BOM: JSON.stringify(this.productDetials.bom)
    };
    // this.BOMData = BOMList;
    this.modalReferenceBOMEntry = this.modalService.open(ProductBOMComponent, { windowClass: 'item-Edit-BOM', backdrop: 'static', keyboard: false });
    this.modalReferenceBOMEntry.componentInstance.mdlRef = this.modalReferenceBOMEntry;
    this.modalReferenceBOMEntry.componentInstance.BOMData = BOMList;
    this.modalReferenceBOMEntry.result.then((result: any) => {
      if(result == 'Done'){
          this.getProductDetail();
      }
    })
    // this.modalReferenceBOMEntry.result.then((result: any) => {
    // this.closeResultBOMEntry = `Closed with: ${result}`;
    // }, (reason: any) => {
    //   this.closeResultBOMEntry = `Dismissed`;
    // });
  }

  //openNewStage() - Redirect to next page
  OpenUnit(content: any){
    let unitList = {
      productID: this.productDetials.productID,
      productName: this.productDetials.productName,
      Unit: JSON.stringify(this.productDetials.units)
    };
    // this.productUnitData= unitList;
    this.modalReferenceUnitEntry = this.modalService.open(ProductUnitsComponent, { windowClass: 'item-Edit-ProductUnit', backdrop: 'static', keyboard: false });
    this.modalReferenceUnitEntry.componentInstance.mdlRef = this.modalReferenceUnitEntry;
    this.modalReferenceUnitEntry.componentInstance.productUnitData = unitList;

    this.modalReferenceUnitEntry.result.then((result: any) => {
      if(result == 'Done'){
          this.getProductDetail();
      }
    });    
  }

  //fn_OpenByproducts() - Open BOM Page
  fn_OpenByproducts(content: any){
    let ByproductList = {
      productID: this.productDetials.productID,
      productName: this.productDetials.productName,
      Byproduct: JSON.stringify(this.productDetials.byProduct)
    };
    // this.ByproductData= ByproductList;
    this.modalReferenceByproductEntry = this.modalService.open(ProductByproductsComponent, { windowClass: 'item-Edit-Byproduct', backdrop: 'static', keyboard: false });
    this.modalReferenceByproductEntry.componentInstance.mdlRef = this.modalReferenceByproductEntry;
    this.modalReferenceByproductEntry.componentInstance.ByproductData = ByproductList;
    this.modalReferenceByproductEntry.result.then((result: any) => {
      if(result == 'Done'){
          this.getProductDetail();
      }
    })
    // this.modalReferenceByproductEntry.result.then((result: any) => {
    // this.closeResultByproductEntry = `Closed with: ${result}`;
    // }, (reason: any) => {
    //   this.closeResultByproductEntry = `Dismissed`;
    // });
    // this.dataSer.fn_dataTransfer(ByproductList);
    // this.router.navigateByUrl('/ProductByproduct?PID=' + this.productDetials.productID);
  }


    //fn_OpenBOM() - Open BOM Page
    fn_OpenUnit(content: any){
     
      // this.BOMData = BOMList;
      this.modalReferenceBOMEntry = this.modalService.open(ProductBOMComponent, { windowClass: 'item-Edit-BOM', backdrop: 'static', keyboard: false });
      this.modalReferenceBOMEntry.componentInstance.mdlRef = this.modalReferenceBOMEntry;
      this.modalReferenceBOMEntry.result.then((result: any) => {
        if(result == 'Done'){
            this.getProductDetail();
        }
      })
      // this.modalReferenceBOMEntry.result.then((result: any) => {
      // this.closeResultBOMEntry = `Closed with: ${result}`;
      // }, (reason: any) => {
      //   this.closeResultBOMEntry = `Dismissed`;
      // });
    }
  

  //getProductDetail() - Get Product Details
  async getProductDetail(){
    let data = [{
      productID: this.productDetials.productID
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'get',
        moduleID: 4,
        data: JSON.stringify(data)
    }];

    return await this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));  
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  async successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          this.productDetials.bom = [];
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
              // this.router.navigateByUrl('/Stock');
          }
          else{
            let productData = reponseData.Table[0];
            this.BasicData = productData;
            this.productDetials.productName = productData.ItemName;
            this.productDetials.productCode = productData.ItemCode;
            this.productDetials.stockQty = productData.CurrQty;
            this.productDetials.stdCost = productData.DefStockRate;
            this.productDetials.leadTime = productData.LeadTime;
            this.productDetials.defPrice = productData.DefPurchRate;
            this.productDetials.unitName = productData.SKU;
            this.productDetials.bom = JSON.parse(productData.BOM);            
            this.productDetials.stages = JSON.parse(productData.StageFlow);
            this.productDetials.byProduct= JSON.parse(productData.Byproducts);
            this.productDetials.units= JSON.parse(productData.Units);
            this.productDetials.isMfg = productData.IsMade;
            this.productDetials.TypeID = productData.TypeID;
            this.productDetials.isActiveStatus = productData.IsActive ? 1 : 0;
            this.productDetials.initQty = productData.InitQty;
            this.productDetials.createdDT = new Date(productData.CreatedDT).setHours(0, 0, 0, 0); 
            this.productDetials.initUnit = productData.InitUnit;

            let category = this.categories.filter((x: any) => x.cid == this.BasicData.CategoryID);
            
            if(category.length > 0){
              this.productDetials.categoryName = category[0].cnm
              let subCategory = category[0]?.sub?.filter((x: any) => x.sid == this.BasicData.SubCategoryID);
              if(subCategory.length > 0){
                this.productDetials.subCategoryName = subCategory[0].snm
              } else {
                this.productDetials.subCategoryName = ''
              }
            }else{
              this.productDetials.categoryName = '';
              this.productDetials.subCategoryName = ''
            }
            
            this.productDetials.HSNID = productData.HSNID

            let tempTAg:any =  productData.Tags
            this.tagList = tempTAg.split(',')
            this.tagList.pop();

            // Send BOM Data to component
            let bomData = {
              productID: this.productDetials.productID,
              productName: this.productDetials.productName,
              BOM: JSON.stringify(this.productDetials.bom)
            };
            await this.dataSer.updateBOMData(bomData);

            //Send byProduct Data To component
            let ByproductList = {
              productID: this.productDetials.productID,
              productName: this.productDetials.productName,
              Byproduct: JSON.stringify(this.productDetials.byProduct)
            };
            this.dataSer.updateByProduct(ByproductList);

            //Send stages Data To component
            let stageList = {
              productID: this.productDetials.productID,
              productName: this.productDetials.productName,
              stages: JSON.stringify(this.productDetials.stages)
            };
            this.dataSer.updateProductStages(stageList);

            //Send Units Data to component 
            let unitList = {
              productID: this.productDetials.productID,
              productName: this.productDetials.productName,
              Unit: JSON.stringify(this.productDetials.units),
              SKU: this.productDetials.unitName,
              XnIDs: this.productDetials.XnIDs
            };
            this.dataSer.updateProductUnits(unitList);
            
            if (this.productDetials.bom.length > 0) {
              let productList: any = [];
              if (this.stockItems && this.stockItems.length > 0) {
                productList = this.stockItems;
              }
              else {
                this.apiService.getIDB('erp_inv', (productList: any) => {
                  if (productList && productList.length > 0) {
                    productList = productList;
                  }
                });
              }

              for (let i = 0; i < this.productDetials.bom.length; i++) {
                let currBOMItem: any = productList.filter((x: any) => x.ItemID == this.productDetials.bom[i].IID);
                let reqQty: any = currBOMItem.length > 0 ? Number(this.productDetials.bom[i].Qty).toFixed(currBOMItem[0].SKUPrecision) : Number(this.productDetials.bom[i].Qty);
                if(currBOMItem.length > 0) {
                  this.productBOMList.push({
                    itemID: this.productDetials.bom[i].IID,
                    itemName: currBOMItem[0].ItemName,
                    itemCode: currBOMItem[0].ItemCode,
                    qty: reqQty,
                    unit: this.productDetials.bom[i].Unt,
                    skuPrcsn: currBOMItem[0].SKUPrecision
                  });
                }           
              }
            }
          }
        }
    }
  }

  //openBasicDataEntry() - Basic Data Entry Open
  openBasicDataEntry(content: any) {
    
    this.modalReferenceItemEntry = this.modalService.open(ItemEntryComponent, { windowClass: 'modal-item-Entry', backdrop: 'static', keyboard: false});
    this.modalReferenceItemEntry.componentInstance.mdlRef = this.modalReferenceItemEntry; 
    this.modalReferenceItemEntry.componentInstance.BasicData = this.BasicData; 
    this.modalReferenceItemEntry.result.then((result: any) => {
           
      
      
      if(result.action == 'Done'){
        this.hasChanges = true;
        this.getProductDetail();
      }
      if(!result.IsMade) {
        let cls = $(".modal-item-Edit");
        if(cls.length > 0){
          $(".modal").removeClass("modal-item-Edit");
          $(".modal").addClass("modal-item-EditOne");
          //$(".modal-item-Edit").attr('modal-item-EditOne');
        }
        
      } 
      
      if(result.IsMade) {
        let cls = $(".modal-item-EditOne");
        if(cls.length > 0){
          $(".modal").removeClass("modal-item-EditOne");
          $(".modal").addClass("modal-item-Edit");
          // $(".modal-item-EditOne").attr('modal-item-Edit');
        }
      } 

    })

    // this.modalReferenceItemEntry.result.then((result: any) => {
    //   this.closeResultEntry = `Closed with: ${result}`;
    // }, (reason: any) => {
    //   this.closeResultEntry = `Dismissed`;
    // });
  }

  // deleteItem() - delete selected item
  deleteItem() {
    if (!this.productDetials.productID) {
      this.apiService.successAlert("Please select a valid item.");
      return;
    }

    var itemDeleteConfirm = confirm("Are you sure you want to delete this item?");
    if (!itemDeleteConfirm) {
      return;
    }

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

      var tempData = [{
        'ItemID': this.productDetials.productID
      }]

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: MyLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'Delete',
        moduleID: 5,
        data: JSON.stringify(tempData)
      }];

      this.apiService.sendChange(myParams, this.successItemDelete.bind(this), this.failureItemDelete.bind(this));
  }

  //failureItemDelete - failure handler for item delete function
  failureItemDelete(res: any) {
    if (res.updatePackage) {
      var reponseData = JSON.parse(res.updatePackage);
      if (reponseData.Table[0].ErrCode == 3 && this.productDetials.isActiveStatus == 1) {
        this.apiService.swalConfirm(reponseData.Table[0].ErrMsg + " Do you want to mark this item as inactive instead?", () => {
          this.changeActiveStatus();
        });
        return;
      }
    }

    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successItemDelete - success handler for item delete function
  successItemDelete(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          this.hasChanges = true;
          this.goBack();
          this.apiService.setCookie("MyLastSyncDT", '');
        }
      }

    }
  }

  editProjectType() {
    this.modalReference = this.modalService.open(ProjectTypeEntryComponent, { windowClass: 'project-type-entry', backdrop: 'static', keyboard: false })
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.projectTypeID = this.productDetials.productID;
    this.modalReference.componentInstance.stockItems = this.stockItems;
    this.modalReference.componentInstance.isEdit = true;
    this.modalReference.result.then((result: any) => {
      if(result && result.action == 'Done') {
        this.getProductDetail();
      }
    })
  }

  confirmStatusChange(): void {
    const confirmMessage = `${this.productDetials.isActiveStatus ? 'Are you sure you want to mark this item as inactive?' : 'Are you sure you want to mark this item as active?'}`;
    this.apiService.swalConfirm(confirmMessage, () => {
      this.changeActiveStatus();
    });
  }
  

  changeActiveStatus(): void {
    const tempData = [{
      ItemID: this.productDetials.productID,
      ChangeType: 'ITMACTIVE',
      BOM: '[]',
      Byproducts: '[]',
      Stages: "",
      Units: '[]',
      IsActiveStatus: !this.productDetials.isActiveStatus ? 1 : 0,
    }];

    const myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setItemDetail',
      moduleID: 5,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successIsActiveStatus.bind(this), this.failureIsActiveStatus.bind(this));
  }

  private successIsActiveStatus(res: any): void {
    if (res.error) {
    }
    else {
      this.productDetials.isActiveStatus = ! this.productDetials.isActiveStatus ? 1 : 0;
      if(this.productDetials.isActiveStatus){
        this.apiService.successAlert('Item marked as active.');
      }
      else{
        this.apiService.successAlert('Item marked as inactive.');
      }
      this.hasChanges = true;
      var reponseData = JSON.parse(res.updatePackage);
      let agencyConfig: any = this.apiService.getCookie('Cfg_AgnCfg');
      if (agencyConfig) {
        agencyConfig = JSON.parse(agencyConfig);
        if (agencyConfig && agencyConfig.length > 0 && reponseData.Table[0].Billable) {
          agencyConfig[0].Billables = reponseData.Table[0].Billable;
        }
        this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(agencyConfig));
      }
    }
 
  }

  private failureIsActiveStatus(error: any): void {
    console.error('Failed to update status:', error);
  }

    //#endregion
}
